module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/pc/en_okinawa-c3e169109f1db75f9efc5087c53ee1d4.png";